import ElectronicBuyNow from './electronic-buy-now';

export default ElectronicBuyNow;
